import gql from 'graphql-tag';

export const GET_CMS_TREADWELL_TAB = gql`
  query CmsTreadwellTab {
    cms {
      page(id: "treadwell-plp") {
        contentSlots {
          position
          name: id
          cmsComponents {
            ... on CmsHtmlComponent {
              html
            }
            ... on CmsToolTipsComponent {
              id
            }
          }
        }
        source
      }
    }
  }
`;
